import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/checkout/cancel')({
  component: CheckoutCancelPage,
});

function CheckoutCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="max-w-md text-center">
        <div className="rounded-full bg-gray-100 dark:bg-gray-800 p-3 inline-block mb-4">
          <svg
            className="w-16 h-16 text-gray-600 dark:text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Checkout Cancelado
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Você cancelou o processo de pagamento. Nenhuma cobrança foi realizada.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate({ to: '/workspaces' })}
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            Voltar para Workspaces
          </button>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    </div>
  );
}
